// Libraries
import styled from 'styled-components'

// Components
import { Icon } from 'heeds-ds'

export const CloseIcon = styled(Icon).attrs((props) => ({
  color: props.theme.colors.icon.onPrimary,
  iconName: 'close',
  size: 14,
}))``

export const FiltersContainer = styled.div`
  display: flex;
  gap: 0.8rem;
  height: 3.2rem;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    height: 0px;
    margin-left: 1px;
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.action.secondaryDefault};
    border-radius: 6px;
  }
`

export const TagButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.icon.default};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: 15px;
  color: ${({ theme }) => theme.colors.text.onPrimary};
  cursor: pointer;
  display: flex;
  font-family: ${({ theme }) => theme.fontFamily.roboto};
  font-size: ${({ theme }) => theme.fontSize.copy4};
  gap: 0.8rem;
  padding: 0.8rem 1.6rem;
  white-space: nowrap;
`
